import React, { useEffect } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditTimeOffRows, selectTimeOffEndDateError } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { startDateModStyles } from '../../StartDate/StartDateMod.styles';
import { differenceInDays, isBefore, isValid } from 'date-fns';
import { findIndex, findRow } from './TimeOffHours';


export const EndDateEditCell = (cellParams: any) => {
  return <NewEndDate cellParams={cellParams} />;
};

const NewEndDate = React.memo(function NewEndDate(cellParams: any) {
  const { classes } = startDateModStyles();
  const { control, formState: { errors } } = useFormContext();
  const dispatch = useDispatch();
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);
  const RowId = cellParams?.cellParams?.id;
  const timeOffEndDateErrors = useSelector(selectTimeOffEndDateError);
  const setDateForTimeOffEdit = date => {
    let newRow = timeOffEditRequests.slice(0);

    let timeOffEditRow = findRow(cellParams, timeOffEditRequests, RowId);

    const daysDiff =
      !isValid(new Date(date)) || isBefore(new Date(date), new Date(cellParams?.cellParams?.row?.startDate))
        ? null
        : differenceInDays(new Date(date), new Date(cellParams?.cellParams?.row?.startDate)) + 1;

    let updatedEndDate = {};

    updatedEndDate = {
      ...timeOffEditRow,
      endDate: date,
      days: daysDiff ? daysDiff : '--',
    };

    let editDateIndex = findIndex(updatedEndDate, cellParams, timeOffEditRequests, RowId);

    newRow[editDateIndex] = updatedEndDate;
    dispatch(placementModsAction.setEditTimeOffRows(newRow));
    dispatch(placementModsAction.setGridModAltered(true));
  };

  useEffect(() => {
    if (cellParams?.cellParams?.error !== null && cellParams?.cellParams?.error !== undefined) {
      const val = timeOffEndDateErrors?.filter(el => el.id === cellParams?.cellParams?.id);

      if (val?.length === 0) {
        const arr = timeOffEndDateErrors?.length > 0 ? timeOffEndDateErrors?.slice(0) : [];
        const valueObj = { endDate: cellParams?.cellParams?.error, id: cellParams?.cellParams?.id };

        arr.push(valueObj);

        dispatch(placementModsAction.setTimeOffEndDateError(arr));
      } else {
        const arr = timeOffEndDateErrors?.slice(0);
        let currentObj = arr.find(val => val.id === cellParams?.cellParams?.id);

        let updatedObj = { ...currentObj, endDate: cellParams?.cellParams?.error };

        let editIndex = arr.findIndex(val => val.id === cellParams?.cellParams?.id);

        arr[editIndex] = updatedObj;

        dispatch(placementModsAction.setTimeOffEndDateError(arr));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cellParams?.cellParams?.error]);

  return (
    <Controller
      control={control}
      name={`timeOffRequests${RowId}.endDate`}
      rules={{ required: true }}
      render={({ field: { onChange, onBlur, value, ...rest } }) => {
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                  setDateForTimeOffEdit(setTo);
                } else {
                  onChange(null);
                  setDateForTimeOffEdit(null);
                }
              }}
              value={cellParams?.cellParams?.row?.endDate}
              onCancel={() => { }}
              clear
              open={false}
              variant="filled"
              quickSelect={false}
              single
              useMaxWidth={true}
              showIcon={true}
              className={cellParams?.cellParams?.row?.endDate ? classes.inputFieldNoLabel : classes.inputFields}
              labelClass={cellParams?.cellParams?.row?.endDate ? classes.hideInputFieldLabel : classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate:
                  cellParams?.cellParams?.row?.endDate && cellParams?.cellParams?.row?.endDate !== '--'
                    ? new Date(cellParams?.cellParams?.row?.endDate)
                    : undefined,
                endDate:
                  cellParams?.cellParams?.row?.endDate && cellParams?.cellParams?.row?.endDate !== '--'
                    ? new Date(cellParams?.cellParams?.row?.endDate)
                    : undefined,
                useLabelAsValue: true,
              }}
              error={!isNullOrUndefined(errors?.newEndDate)}
              helperText={!isNullOrUndefined(errors?.newEndDate) ? errors?.newEndDate?.message : undefined}
            />
          </React.Fragment>
        );
      }}
    />
  );
});
